import Vue from "vue";
import Vuex from "vuex";
import { getStoreBuilder } from "vuex-typex";

// Each module must be explicitly imported here
// so that they are built before the store is built.
import "./ProductModule";
import "./AppModule";
import "../modules/ProductConfigurator/store/index";
import "../modules/ResellerOrderCheckout/store/index";
import "./DeliveriesModule";

import { ProductState } from "./ProductModule";
import { AppState } from "./AppModule";
import { ProductConfiguratorState } from "../modules/ProductConfigurator/store/index";
import { ResellerOrderCheckoutState } from "../modules/ResellerOrderCheckout/store/index";
import { DeliveriesState } from "./DeliveriesModule";

Vue.use(Vuex);

export interface RootState {
    product: ProductState;
    appSettings: AppState;
    productConfigurator: ProductConfiguratorState;
    resellerOrderCheckout: ResellerOrderCheckoutState;
    deliveries: DeliveriesState;
}

const store = getStoreBuilder<RootState>().vuexStore();

export default store;
